document.addEventListener('DOMContentLoaded', function() {
  
  let currentTooltip = null;
  
  function showVariantName(element) {
    // Remover tooltip anterior
    if (currentTooltip) {
      currentTooltip.remove();
      currentTooltip = null;
    }
    
    // Obtener el nombre directamente del atributo data-swatch-option
    let variantName = element.getAttribute('data-swatch-option');
    
    console.log('data-swatch-option:', variantName);
    console.log('Todos los atributos:', element.attributes);
    
    // Si no hay nombre, buscar en otros atributos
    if (!variantName) {
      variantName = element.getAttribute('data-value') ||
                   element.getAttribute('aria-label') ||
                   element.getAttribute('title');
    }
    
    // Buscar en la imagen
    if (!variantName) {
      const img = element.querySelector('img');
      if (img) {
        variantName = img.getAttribute('alt') || img.getAttribute('title');
      }
    }
    
    // Valor por defecto
    if (!variantName || variantName === '') {
      variantName = 'Color seleccionado';
    }
    
    console.log('Nombre final a mostrar:', variantName);
    
    // Crear el tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'variant-tooltip';
    tooltip.textContent = variantName;
    
    // Posicionar el tooltip
    const rect = element.getBoundingClientRect();
    tooltip.style.position = 'fixed';
    tooltip.style.left = (rect.left + rect.width / 2) + 'px';
    tooltip.style.top = (rect.top - 45) + 'px';
    tooltip.style.transform = 'translateX(-50%)';
    tooltip.style.zIndex = '9999';
    
    document.body.appendChild(tooltip);
    currentTooltip = tooltip;
    
    // Mostrar con animación
    setTimeout(() => {
      tooltip.classList.add('show');
    }, 10);
    
    // Auto-ocultar después de 2.5 segundos
    setTimeout(() => {
      if (currentTooltip) {
        currentTooltip.classList.remove('show');
        setTimeout(() => {
          if (currentTooltip) {
            currentTooltip.remove();
            currentTooltip = null;
          }
        }, 300);
      }
    }, 2500);
  }
  
  // Escuchar clics en las variantes
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('span[data-swatch-option]');
    if (swatch) {
      console.log('Variante clickeada:', swatch);
      setTimeout(() => {
        showVariantName(swatch);
      }, 100);
    }
  });
  
});
